export default __webpack_public_path__ + "static/media/close.aeec27d3.png";